import { render, staticRenderFns } from "./AnchorPageObjectives.vue?vue&type=template&id=29af3486&scoped=true"
import script from "./AnchorPageObjectives.vue?vue&type=script&lang=js"
export * from "./AnchorPageObjectives.vue?vue&type=script&lang=js"
import style0 from "./AnchorPageObjectives.vue?vue&type=style&index=0&id=29af3486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29af3486",
  null
  
)

export default component.exports